import { HorizontalLineInterface } from 'common/types/entities/HorizontalLineInterface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { createHorizontalLine } from 'src/shared/entities/horizontal-line/create-horizontal-line'
import {
  migrateMargin,
  migrateMobileMargin,
  migrateFullBorderType,
} from '../utils/migrateUtils'

export function migrateHorizontalLine(
  entity: OldEntityInterface,
): HorizontalLineInterface {
  const horizontalLine = createHorizontalLine(
    entity.parentId,
    entity.masterBlockId,
  )

  //id and masterBlock
  horizontalLine.id = entity.id
  if (entity.isMasterBlockRoot) {
    horizontalLine.isMasterBlockRoot = true
  }
  //appearance
  if (entity.options.appearance) {
    horizontalLine.appearance = entity.options.appearance
  }
  //attrId
  horizontalLine.htmlAttrId = entity.options.attrId

  //margins
  migrateMargin(horizontalLine, entity)
  migrateMobileMargin(horizontalLine, entity)
  migrateFullBorderType(horizontalLine, entity)

  return horizontalLine
}
